import type { ReactElement } from 'react';
import type { IconRenderProps } from '../types';

export function InstagramIcon({
	width,
	height,
	active = false,
	customIconColor,
	'aria-label': ariaLabel = 'Instagram',
	style,
	...rest
}: IconRenderProps): ReactElement {
	const bg = customIconColor?.bgColor ?? '#FFFFFF';
	const g = customIconColor?.glyphColor ?? (active ? '#1E1E1E' : 'rgba(30, 30, 30, 0.48)');

	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={width ?? '100%'}
			height={height ?? '100%'}
			viewBox="0 0 40 40"
			fill="none"
			role="img"
			aria-label={ariaLabel}
			style={{ display: 'block', ...style }}
			{...rest}
		>
			<title>Instagram</title>
			<path
				d="M33.6188 40H6.38086C2.86255 40 0 37.1375 0 33.6188V6.38086C0 2.86255 2.86255 0 6.38086 0H33.6188C37.1375 0 39.9996 2.86255 39.9996 6.38086V33.6188C39.9996 37.1375 37.1371 40 33.6188 40Z"
				fill={bg}
			/>
			<path
				d="M24.066 10.6213C25.2181 10.6213 26.3007 11.0697 27.1155 11.8845C27.9303 12.6993 28.3787 13.7819 28.3787 14.934V24.066C28.3787 25.2181 27.9303 26.3007 27.1155 27.1155C26.3007 27.9303 25.2181 28.3787 24.066 28.3787H14.934C13.7819 28.3787 12.6993 27.9303 11.8845 27.1155C11.0697 26.3007 10.6213 25.2181 10.6213 24.066V14.934C10.6213 13.7819 11.0697 12.6993 11.8845 11.8845C12.6993 11.0697 13.7819 10.6213 14.934 10.6213H24.066ZM24.066 9H14.934C11.6572 9 9 11.6572 9 14.934V24.066C9 27.3428 11.6572 30 14.934 30H24.066C27.3428 30 30 27.3428 30 24.066V14.934C30 11.6572 27.3428 9 24.066 9ZM19.5 16.2678C20.5369 16.2678 21.5116 16.6716 22.2444 17.4044C22.9772 18.1372 23.3809 19.1118 23.3809 20.1487C23.3809 21.1856 22.9772 22.1603 22.2444 22.8931C21.5116 23.6259 20.5369 24.0297 19.5 24.0297C18.4631 24.0297 17.4884 23.6259 16.7556 22.8931C16.0228 22.1603 15.6191 21.1856 15.6191 20.1487C15.6191 19.1118 16.0228 18.1372 16.7556 17.4044C17.4884 16.6716 18.4631 16.2678 19.5 16.2678ZM19.5 14.6455C16.4609 14.6455 13.9967 17.1096 13.9967 20.1487C13.9967 23.1879 16.4609 25.652 19.5 25.652C22.5391 25.652 25.0033 23.1879 25.0033 20.1487C25.0033 17.1096 22.5391 14.6455 19.5 14.6455ZM26.2125 13.7705C26.2125 13.239 25.7817 12.8083 25.2503 12.8083C24.7189 12.8083 24.2881 13.239 24.2881 13.7705C24.2881 14.3019 24.7189 14.7327 25.2503 14.7327C25.7817 14.7327 26.2125 14.3019 26.2125 13.7705Z"
				fill={g}
				stroke={g}
				strokeWidth="0.8"
			/>
		</svg>
	);
}
